// import dateCourseApi from '../../api/dateCourse';

export const moduleId = 'dateCourse';

const state = {
  //查询出来的日期
  date:{},
  highlighted:[],
  //右侧资源数据
  sourceList: [],
  //右侧选中数据
  selectSource:null,
  resourceId:null,
  loading:false

};
const getters = {

};

const mutations = {
  date(state,data){
    state.date = data;
  },
  sourceList(state,data){
    state.sourceList = data;
  },
  setSelectSource(state,data){
    state.selectSource = data;
  },
  setResourceId(state,data){
    state.resourceId = data;
  },
  setTask(state,data){
    state.highlighted = data;
  },
  setLoading(state,data){
    state.loading = data;
  }
};

const actions = {
  // 查询科目
  async queryDate({state,commit,}) {
    commit('date', {date:new Date()});
    commit('setSelectSource', state.sourceList[0]);
    commit('setResourceId', state.sourceList[0].id);
  },
  //根据日期请求资源
  async querySource({state,commit},params){
    commit('setLoading',true);
    let res = await dateCourseApi.selectSource(params);
    if (res.data.code == "0") {
      commit('setLoading',false);
      console.log(res);
      if(res.data.data.list.length == 0){
        commit('sourceList', []);
        commit('setSelectSource',null);
      }else{
        commit('sourceList', res.data.data.list);
        commit('setSelectSource', state.sourceList[0]);
        commit('setResourceId', state.sourceList[0].id);
      }

    }
  },
  //右侧选中数据
  selectSource({state,commit},params){
    let data;
    state.sourceList.map(function (item) {
      if(item.id === params){
        data = item;
        return true;
      }
    })
    commit('setSelectSource',data);
  },
  setResourceId({state,commit}, data) {
    commit('setResourceId', data);
  },
  // 获取当月的所有任务
  async selectTask({state,commit}, params){
    let res = await dateCourseApi.selectTask(params);
    if(res.data.code == "0"){
       // commit('setTask', ['2019-9-5','2019-9-10']);
    }

  },
  //根据开始时间，结束时间 获取当月的所有任务
  async selectTaskByTime({state,commit},params){
    commit('setLoading',true);
    let res = await dateCourseApi.selectTaskByTime(params);
    if(res.data.code == "0"){
      commit('setLoading',false);
      commit('setTask', res.data.data);
      commit('setSelectSource', state.sourceList[0]);
      commit('setResourceId', state.sourceList[0].id);
    }
  }

};
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/dateCourse.js